import { httpClient } from "../lib/axios";

export const api_getUsers = async () => {
  return await httpClient
    .get("app_user/")
    .then(res => {
      return res.data;
    })
    .catch(err => {
      console.log(err);
      return err;
    });
};

export const api_addUser = async payload => {
  return await httpClient
    .post("app_user/", payload)
    .then(res => {
      return res.data;
    })
    .catch(err => {
      return err;
    });
};

export const api_getRoles = async () => {
  return await httpClient
    .post("crud/", {
      function_type: "read_all",
      data: null,
      many: true,
      app_name: "com",
      model_name: "roles",
    })
    .then(res => {
      let modified_data = res.data?.data.map(e => {
        return {
          label: e.name,
          value: e.id,
        };
      });
      return modified_data;
    })
    .catch(err => {
      return err;
    });
};

export const api_getRoute = async () => {
  return await httpClient
    .post("crud/", {
      function_type: "read_all",
      data: null,
      many: true,
      app_name: "com",
      model_name: "route",
    })
    .then(res => {
      let modified_data = res.data?.data.map(e => {
        return {
          label: e.name,
          value: e.id,
        };
      });
      return modified_data;
    })
    .catch(err => {
      return err;
    });
};

// Filter master
export const api_filter = async (model, filter, fields,serializer_class,counterId, page_number = 1, page_size = 10, is_export = false) => {
  return await httpClient
    .post("filter/", {
      model: model,
      filter: filter,
      fields: fields,
      serializer_class:serializer_class,
      page_number,
      page_size,
      is_export,
      counter_id: counterId
    })
    .then(res => {
      return res.data;
    })
    .catch(err => {
      return err;
    });
};

export const api_saveMaintenance = async (payload) => {
  return await httpClient
    .post("website_maintenance/", payload)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const get_website_maintenance= async () => {
  return await httpClient
    .get("website_maintenance/") // your Django GET URL
    .then(res => res.data)
    .catch(err => {
      console.error(err);
      return { success: false, data: null };
    });
};

export const get_dashboard_data = async (report_type = "days",range) => {
  return await httpClient
    .get("dash_board/", { params: { report_type: report_type , range : range,} })
    .then(res => res.data)
    .catch(err => {
      console.error(err);
      return { success: false, data: null };
    });
};

export const update_lat_long = async (id, lat = 0, long = 0) => {
  return await httpClient
    .put("address/", {id: id, latitude: lat, longitude: long })
    .then(res => res.data)
    .catch(err => {
      console.error(err);
      return { success: false, data: null };
    });
}